import { convertEnumFilterToApi } from 'v5/platform/filters/filterConverters';
import { Nullable } from 'v5/platform/typescript';

export function mergeWorkspaceScopingIntoHttpFilters(query: {
  workspaceId: Nullable<number>;
}): Record<string, unknown> {
  if (query.workspaceId === null) {
    return {};
  }

  return {
    enterprise_workspace_id: convertEnumFilterToApi({
      operator: 'matchAny',
      value: [query.workspaceId]
    })
  };
}
